/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EOfferAcceptanceResponseDto } from './EOfferAcceptanceResponseDto';
import type { QuoteResponseDto } from './QuoteResponseDto';
export type EOfferResponseDto = {
    /**
     * eOffer ID
     */
    id: string;
    /**
     * Quote ID
     */
    quoteId: string;
    /**
     * eOffer status
     */
    status: EOfferResponseDto.status;
    /**
     * Recipient email address
     */
    recipientEmail?: string;
    /**
     * Recipient name
     */
    recipientName?: string;
    /**
     * Email message
     */
    emailMessage?: string;
    /**
     * Sent timestamp
     */
    sentAt?: string;
    /**
     * Expiration date
     */
    expiresAt: string;
    /**
     * Declined timestamp
     */
    declinedAt?: string;
    /**
     * Decline reason
     */
    declineReason?: string;
    /**
     * Total premium
     */
    totalPremium?: number;
    /**
     * Total commission
     */
    totalCommission?: number;
    /**
     * Total tax
     */
    totalTax?: number;
    /**
     * Policy total tax (15% of net premium + fees)
     */
    policyTotalTax?: number;
    /**
     * Total net premium
     */
    totalNetPremium?: number;
    /**
     * Total tax on commission
     */
    totalTaxOnCommission?: number;
    /**
     * Admin fee
     */
    adminFee?: number;
    /**
     * Broker fee
     */
    brokerFee?: number;
    /**
     * Total (totalPremium + adminFee + brokerFee)
     */
    total?: number;
    /**
     * Ando quote ID
     */
    andoQuoteId?: string;
    /**
     * Ando quote request snapshot (JSON)
     */
    andoQuoteRequest?: Record<string, any>;
    /**
     * Ando quote response snapshot (JSON)
     */
    andoQuoteResponse?: Record<string, any>;
    /**
     * Per-risk premium details from Ando response (JSON array)
     */
    riskPremiums?: Record<string, any>;
    /**
     * User ID who sent the eOffer
     */
    sentBy?: string;
    /**
     * Creation timestamp
     */
    createdAt: string;
    /**
     * Last update timestamp
     */
    updatedAt: string;
    /**
     * Acceptance details if accepted
     */
    acceptance?: EOfferAcceptanceResponseDto;
    /**
     * Quote details with risks
     */
    quote?: QuoteResponseDto;
};
export namespace EOfferResponseDto {
    /**
     * eOffer status
     */
    export enum status {
        DRAFT = 'DRAFT',
        SENT = 'SENT',
        VIEWED = 'VIEWED',
        PARTIALLY_COMPLETED = 'PARTIALLY_COMPLETED',
        BIND_FAILED = 'BIND_FAILED',
        ACCEPTED = 'ACCEPTED',
        DECLINED = 'DECLINED',
        EXPIRED = 'EXPIRED',
    }
}

